import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "pie-chart-wrapper mt-5 flex items-center justify-center" }
const _hoisted_2 = {
  key: 1,
  class: "chart-overlay absolute flex items-center justify-center text-center dark:bg-dark"
}
const _hoisted_3 = { class: "pt-4 text-xl font-light leading-none text-gray-500 dark:text-gray-400" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold text-blue" }, "Gas", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = { class: "text-sm font-semibold leading-none" }
const _hoisted_7 = { key: 2 }

import { ref } from 'vue';
import moment from 'moment';
import AppLoader from '@/components/ui/AppLoader.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PieChart',
  props: {
  chartData: {
    type: Array
  }
},
  setup(__props) {

const props = __props;

const today = ref(moment().format('D MMM'));



// set up chart layout and options
const chartOptions = ref({
  title: '',
  chart: {
    style: {
      fontFamily: 'Source Sans Pro'
    },
    backgroundColor: null,
    width: 300,
    height: 300,
    plotBackgroundColor: null,
    plotBorderWidth: null,
    plotShadow: false,
    type: 'pie'
  },
  legend: {
    enabled: false
  },
  plotOptions: {
    pie: {
      minSize: 300,
      allowPointSelect: true,
      cursor: 'pointer',
      dataLabels: {
        useHTML: true,
        shadow: false,
        overflow: 'allow',
        crop: false,
        style: {
          fontSize: 12,
          fontFamily: 'Source Sans Pro',
          color: '#6B7280',
          textAlign: 'center',
          fontWeight: 'light'
        },
        format: '<p class="hc-label"><b>{point.name}</b> <br /> <span>{point.percentage:.1f} %</span></p>'
      }
    }
  },
  tooltip: {
    enabled: false,
  },
  accessibility: {
    point: {
      valueSuffix: '%'
    }
  },
  xAxis: {
    type: 'datetime',
    labels: {
      format: '{value:%d %b %Y}',
    }
  },
  yAxis: [{
    gridLineColor: '#E3E3E3',
    title: {
      // text: props.yAxisTitle
    }
  }],
  series: [
    {
      name: 'Voorraad',
      colorByPoint: true,
      data: props.chartData,
      point: {
        events: {
          click(e: Event) {
            e.preventDefault(); // prevent any action from occuring on "click" event
          }
        },
      }
    }
  ],
  credits: {
    enabled: false
  },
});

return (_ctx: any,_cache: any) => {
  const _component_highcharts = _resolveComponent("highcharts")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.chartData?.length)
      ? (_openBlock(), _createBlock(_component_highcharts, {
          key: 0,
          class: "chart",
          options: chartOptions.value,
          ref: "chart"
        }, null, 8, ["options"]))
      : _createCommentVNode("", true),
    (__props.chartData?.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("p", _hoisted_3, [
            _hoisted_4,
            _createTextVNode(" voorraad "),
            _hoisted_5,
            _createElementVNode("span", _hoisted_6, _toDisplayString(today.value), 1)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createVNode(AppLoader)
        ]))
  ]))
}
}

})